const { REACT_APP_FRONTEND_URL } = process.env;

export const generateProductDetailsUrl = (
  id,
  productName = "",
  subtitle = "",
  url
) => {
  console.log("hituirtyruytry");
  const slugify = (text) =>
    text
      ?.trim()
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-");

  if (!productName) {
    return `/product-details/${id}`;
  }

  const productSlug = slugify(productName);
  const subtitleSlug = subtitle ? `-${slugify(subtitle)}` : "";

  return url
    ? `${REACT_APP_FRONTEND_URL}box-break-detail/${productSlug}/${id}`
    : `${REACT_APP_FRONTEND_URL}product-details/${productSlug}${subtitleSlug}/${id}`;
};
